import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { jobTypeOptionsCards} from "../../../LinkedinRequests/linkedinrequests-options";

const TypeLinkedinCardsDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {

  return (
    <Dropdown
      value={options.value}
      options={jobTypeOptionsCards}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo"
      showClear
    />
  );
};
export default TypeLinkedinCardsDropdown;

